import React, { Component } from "react";
import { Link } from "react-router-dom";
class Main extends Component {
  state = {
    posts: [],
    filteredFairyTales: [],
    filteredArticles: [],
  };

  async componentDidMount() {
    await this.fetchPostsFromFirestore();
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentPath !== prevProps.currentPath) {
      this.filterContent();
    }
  }

  fetchPostsFromFirestore = async () => {
    try {
      const q = query(collection(db, "posts"));
      const querySnapshot = await getDocs(q);
      const posts = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      this.setState({ posts }, () => this.filterContent());
    } catch (error) {
      console.error("Błąd podczas pobierania postów:", error);
      this.setState({ posts: [] }, () => this.filterContent());
    }
  };

  filterContent = () => {
    const localDataFairyTales = LatestData.latest["fairy-tales"];
    const localDataArticles = LatestData.latest["articles"];

    const allPosts = [...this.state.posts, ...localDataFairyTales, ...localDataArticles];

    const filteredFairyTales = [
      ...allPosts.filter((post) => post.category === "bajki"),
      ...localDataFairyTales
    ];

    const filteredArticles = [
      ...allPosts.filter((post) => post.category === "artykuły"),
      ...localDataArticles
    ];

    this.setState({
      filteredFairyTales,
      filteredArticles,
    });

  };

  render() {
    const { filteredFairyTales, filteredArticles } = this.state;

    return (
        <main>
          <article className="main">
            <header className="header">
              <p className="header__text">Bajki terapeutyczne dla dzieci</p>
            </header>
            <div className="main__latest--heading">
              <h3>Najnowsze bajki</h3>
              <div className="main__latest">
                {filteredFairyTales.slice(0, 4).map((latest, index) => {
                  const image =
                      latest.imageUrl || `/img/${latest.slug}.jpg`;

                  return (
                      <Link
                          key={index}
                          to={`/bajki/${latest.slug}`}
                          className="article__box main__latest--secondary"
                      >
                        <h1 className="article__header">{latest.header}</h1>
                        <p className="article__description">{latest.description}</p>
                        <img
                            className="article__image"
                            src={image}
                            alt={latest.header}
                        />
                      </Link>
                  );
                })}
              </div>
            </div>
          </article>

          <header className="header__second">
            <p className="header__text">A dla starszych czytelników...</p>
          </header>
          <div className="main__latest--heading">
            <h3>Najnowsze artykuły</h3>
            <div className="main__latest" style={{ justifyContent: "center" }}>
              {filteredArticles.slice(0, 4).map((latest, index) => {
                const image =
                    latest.imageUrl || `/img/${latest.slug}_small.jpg`;

                return (
                    <Link
                        key={index}
                        to={`/artykuly/${latest.slug}`}
                        className="article__box main__latest--secondary"
                        style={{ flex: "0" }}
                    >
                      <h1 className="article__header">{latest.header}</h1>
                      <p className="article__description">{latest.description}</p>
                      <img
                          className="article__image"
                          src={image}
                          alt={latest.header}
                      />
                    </Link>
                );
              })}
            </div>
          </div>

          {/* Informacja o prawach autorskich */}
          <div className="contact-form__text">
            <p>
              Wszystkie bajki, artykuły i grafiki na stronie alebaja.com.pl są
              mojego autorstwa. Można je kopiować i drukować dla własnego użytku
              w domowym zaciszu. Jednak, gdyby ktoś chciał je publikować na
              innych stronach, mediach to proszę o wcześniejszy kontakt ze mną
              za pomocą formularza. Indywidualnie rozpatrzę taką możliwość.
            </p>
          </div>
        </main>
    );
  }
}
import "./main.scss";
import LatestData from "../../data/latest.json";
import { collection, getDocs, query } from "firebase/firestore";

import { db } from "../../firebase";

export default Main;
